<template>
  <div>
    <slot />

    <slot
      v-if="mediaLoaded"
      name="ctaBannerTop"
    />

    <XLazyMedia
      v-if="!isOembedPlaying"
      :media="thumbnail"
      :mediaClass="[$style['oembed-cover']]"
      @click.native="playOembed"
      @mediaLoaded="emitMediaLoaded"
    />

    <div
      v-else
      :class="$style['oembed']"
      :style="{ paddingBottom: oembedRatio + '%' }"
    >
      <div v-html="oembed.html" />
    </div>

    <slot
      v-if="mediaLoaded"
      name="ctaBannerBottom"
    />

    <slot name="footer" />
  </div>
</template>

<script>
import Mixin from './mixin'

export default {
  mixins: [Mixin],

  props: {
    oembed: {
      type: Object
    }
  },

  data () {
    return {
      isOembedPlaying: false
    }
  },

  computed: {
    oembedRatio () {
      return (this.oembed.height / this.oembed.width * 100) || 56.25
    }
  },

  methods: {
    playOembed () {
      this.isOembedPlaying = true
    }
  }
}
</script>

<style module>
.oembed-cover {
  width: 100%;
  cursor: pointer;
}

.oembed {
  overflow: hidden;
  position: relative;
  height: 0;
  background: #000;
}

.oembed iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
